export let getWifiPackages =
    {
        error: false,
        data: {
            'responseHeader': {
                'statusCode': 'SUCCESS',
                'clientTransactionId': 'ffcf1adb-ac90-413b-b900-f2e23312b6da',
                'serverTransactionId': '8f70a781-fb3e-44a5-8b69-90e4039fcea7'
            },
            'messageList': [],
            'data': [
                {
                    'id': 1,
                    'name_tr': 'Sınırsız Internet',
                    'name_en': 'Unlimited Internet',
                    'description_tr': 'Sınırsız Internet',
                    'description_en': 'Unlimited Internet',
                    'info_tr': null,
                    'info_en': null,
                    'info_desc_tr': null,
                    'info_desc_en': null,
                    'priceUSD': 25.0,
                    'priceTL': 25.0,
                    'priceMile': 4250.0,
                    'packageNames': [],
                    'packageInfos': [],
                    'packageDescriptions': [],
                    'packageInfoDescs': []
                },
                {
                    'id': 2,
                    'name_tr': '1 GB Internet',
                    'name_en': '1 GB Internet',
                    'description_tr': '1 GB Internet',
                    'description_en': '1 GB Internet',
                    'info_tr': null,
                    'info_en': null,
                    'info_desc_tr': null,
                    'info_desc_en': null,
                    'priceUSD': 20.0,
                    'priceTL': 20.0,
                    'priceMile': 3500.0,
                    'packageNames': [],
                    'packageInfos': [],
                    'packageDescriptions': [],
                    'packageInfoDescs': []
                },
                {
                    'id': 3,
                    'name_tr': '500 MB Internet',
                    'name_en': '500 MB Internet',
                    'description_tr': '500 MB Internet',
                    'description_en': '500 MB Internet',
                    'info_tr': null,
                    'info_en': null,
                    'info_desc_tr': null,
                    'info_desc_en': null,
                    'priceUSD': 15.0,
                    'priceTL': 15.0,
                    'priceMile': 2500.0,
                    'packageNames': [],
                    'packageInfos': [],
                    'packageDescriptions': [],
                    'packageInfoDescs': []
                },
                {
                    'id': 4,
                    'name_tr': '250 MB Internet',
                    'name_en': '250 MB Internet',
                    'description_tr': '250 MB Internet',
                    'description_en': '250 MB Internet',
                    'info_tr': null,
                    'info_en': null,
                    'info_desc_tr': null,
                    'info_desc_en': null,
                    'priceUSD': 9.0,
                    'priceTL': 9.0,
                    'priceMile': 1500.0,
                    'packageNames': [],
                    'packageInfos': [],
                    'packageDescriptions': [],
                    'packageInfoDescs': []
                },
                {
                    'id': 5,
                    'name_tr': 'Sınırsız Mesajlaşma',
                    'name_en': 'Unlimited Chat',
                    'description_tr': 'Miles&Smiles Üyelerine Sınırsız Mesajlaşma',
                    'description_en': 'Unlimited Chat For Miles&Smiles Members',
                    'info_tr': 'Sınırsız Mesajlaşma',
                    'info_en': 'Unlimited Chat',
                    'info_desc_tr': 'Miles&Smiles Üyelerine Sınırsız Mesajlaşma',
                    'info_desc_en': 'Unlimited Chat For Miles&Smiles Members',
                    'priceUSD': 3.0,
                    'priceTL': 3.0,
                    'priceMile': 500.0,
                    'packageNames': [],
                    'packageInfos': [],
                    'packageDescriptions': [],
                    'packageInfoDescs': [],
                    'mileListing': false
                }
            ],
            'loginStatus': null
        }
    };